import { render, staticRenderFns } from "./SchoolYearInput.vue?vue&type=template&id=a6b31cf4"
import script from "./SchoolYearInput.vue?vue&type=script&lang=js"
export * from "./SchoolYearInput.vue?vue&type=script&lang=js"
import style0 from "./SchoolYearInput.vue?vue&type=style&index=0&id=a6b31cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports